import PictureComponent from "components/core/picture/picture-component";
import {
  BRAND_BLACK_TEXT_COLOR,
  CRM_DARKER_TINT_02_COLOR_NAME,
  WHITE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  DEV_DARKER_TINT_02_COLOR_NAME
} from "styles/color-consts";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { isDarkTheme } from "segments/segments-service";
import { useMemo } from "react";
import colors from "styles/colors";
import classnames from "classnames";
import ProductCardTitle from "./product-card-title/product-card-title";
import ProductCardContent from "./product-card-content/product-card-content";
import ProductCardFeatures from "./product-card-features/product-card-features";
import DefaultProps from "./default-props";
import { componentStyles } from "./product-card.scss";

const PRODUCT_TO_COLORS = {
  [WORK_MANAGEMENT_PRODUCT_ID]: WORK_OS_IRIS_COLOR_NAME,
  [CRM_PRODUCT_ID]: CRM_DARKER_TINT_02_COLOR_NAME,
  [DEV_PRODUCT_ID]: DEV_DARKER_TINT_02_COLOR_NAME
};

const ProductCard = ({
  productType = WORK_MANAGEMENT_PRODUCT_ID,
  cardTitle,
  cardBackgroundColor,
  cardTitleConfig,
  cardContent,
  cardAsset,
  isCondensed,
  showUseCasesVertically
}) => {
  const { features, cardPaddingTop, cardPaddingBottom, ...restOfCardContent } = cardContent || {};

  const cardStyle = useMemo(
    () => ({
      backgroundColor: colors[cardBackgroundColor],
      color: isDarkTheme(cardBackgroundColor) ? colors[WHITE_COLOR_NAME] : colors[BRAND_BLACK_TEXT_COLOR],
      paddingTop: cardPaddingTop,
      paddingBottom: cardPaddingBottom
    }),
    [cardBackgroundColor]
  );

  return (
    <div className={classnames("product-card-component", { "condensed-card": isCondensed })} style={cardStyle}>
      <div className="card-top">
        <div className="product-details">
          <ProductCardTitle {...cardTitle} titleConfig={cardTitleConfig} color={PRODUCT_TO_COLORS[productType]} />
          <ProductCardContent
            productType={productType}
            productColor={PRODUCT_TO_COLORS[productType]}
            showUseCasesVertically={showUseCasesVertically}
            {...restOfCardContent}
          />
        </div>
        <div className="product-image">
          <PictureComponent src={cardAsset} />
        </div>
      </div>
      {features?.length > 0 && <ProductCardFeatures features={features} />}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ProductCard;

ProductCard.defaultProps = DefaultProps;
